export const ASSET_TAB = {
  HOLD: 'HOLD',
  FINISH: 'FINISH',
} as const

export const NOTIFICATION_TAP = {
  NOTICE: 'NOTICE',
  NOTIFICATION: 'NOTIFICATION',
} as const

export const MARKET_TAB = {
  SALE: 'SALE',
  SALE_OFF: 'SALE_OFF',
} as const

export const PRODUCT_TAB = {
  INVESTMENT: 'INVESTMENT',
  WORK: 'WORK',
} as const

type ASSET_TAB_TYPE = (typeof ASSET_TAB)[keyof typeof ASSET_TAB]
type NOTIFICATION_TAP_TYPE = (typeof NOTIFICATION_TAP)[keyof typeof NOTIFICATION_TAP]
type MARKET_TAB_TYPE = (typeof MARKET_TAB)[keyof typeof MARKET_TAB]
type PRODUCT_TAB_TYPE = (typeof PRODUCT_TAB)[keyof typeof PRODUCT_TAB]

export type { MARKET_TAB_TYPE, ASSET_TAB_TYPE, NOTIFICATION_TAP_TYPE, PRODUCT_TAB_TYPE }
